module.exports = __webpack_public_path__ + "static/img/4_1_1.ca5e7ef7.jpg";